export default function isSupporter() {
	return localStorage.getItem('support') === 'verified'
}
